import View from './view';

import { unixts, fmt, parseYYYYMMDD } from '../utils/date';

export default View.extend( {

    onBind(model) {
        const dt = fmt( this.model.get( this.options.bindProperty ) || null, 'YYYY-MM-DD HH:mm' ) || null;
        this.lastDateValue_ = this.lastTimeValue_ = dt;
        if (this.lastDateValue_)
            this.parsedDate_ = this.lastDateValue_.split( ' ' );
        else    
            this.parsedDate_ = ['', ''];

        this.parsedDate_[1] = this.parsedDate_[1].substring( 0, 5 ); // truncate :ss
    },

    onUnBind() {
        this.parsedDate_ = ['', ''];
    },

    computeds: {

        date: {
            get() {
                const current = fmt( this.model.get( this.options.bindProperty ) || null, 'YYYY-MM-DD HH:mm' ) || null;

                let changed = false;
                if (current === null && this.lastDateValue_ !== null)
                    changed = true;
                else if (current !== null && this.lastDateValue_ === null)
                    changed = true;
                else if (current !== this.lastDateValue_)
                    changed = true;

                if (changed)
                    return this.lastDateValue_ = current,
                        this.parsedDate_[0] = current ? current.split( ' ' )[0] : '';

                return this.parsedDate_[0];
            },

            set(value) {
                this.parsedDate_[0] = value;
                this.updateBoundProperty( this.parsedDate_ );
            },
        },

        time: {
            get() {
                const current = fmt( this.model.get( this.options.bindProperty ) || null, 'YYYY-MM-DD HH:mm' ) || null
                
                let changed = false;
                if (current === null && this.lastTimeValue_ !== null)
                    changed = true;
                else if (current !== null && this.lastTimeValue_ === null)
                    changed = true;
                else if (current !== this.lastTimeValue_)
                    changed = true;
                    
                if (changed)
                    return this.lastTimeValue_ = current,
                        this.parsedDate_[1] = current ? current.split( ' ' )[1].substring( 0, 5 ) : '';  // truncate :ss

                return this.parsedDate_[1];
            },

            set(value) {
                this.parsedDate_[1] = value;
                this.updateBoundProperty( this.parsedDate_ );
            },
        },

    },

    updateBoundProperty(parsedDate) {
        if (!parsedDate[0] || !parsedDate[1])
            return this.setBinding( this.options.bindProperty, 
                this.lastDateValue_ = this.lastTimeValue_ = null );

        const text = `${parsedDate[0]} ${parsedDate[1]}:00`;

        this.setBinding( this.options.bindProperty, 
            unixts( parseYYYYMMDD( this.lastDateValue_ = this.lastTimeValue_ = text ) ) );
    }

} );


// WEBPACK FOOTER //
// ./src/js/view/field.datetime.js